var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sp_meeting_widget_container"},[_c('iframe',{ref:"iframe",staticClass:"sp_meeting_widget",attrs:{"src":_vm.resolvedLink}})])
}
var staticRenderFns = []

export { render, staticRenderFns }